export default "__VITE_ASSET__D5lcRvuc__"